import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { StakkoProvider, StakkoShell } from './stakko'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <StakkoProvider appId="monopoly">
      <StakkoShell>
        <App />
      </StakkoShell>
    </StakkoProvider>
  </React.StrictMode>
)